export default __webpack_public_path__ + "static/media/K6HJj6llqGM4ehUGVcc1Bph9B0J2.63d4de36.jpg";